import { useNavigate, useParams } from "react-router-dom";
import { useIssuesListGetOneQuery, useIssuesTrackerMutation, useIssuesFeedbackMutation } from "../../service/apiSlices/accessApiService";
import { useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, Button, Card, CardContent, CardHeader, CardMedia, IconButton, Modal, Grid, Skeleton, Typography, FormControl, Select, MenuItem, TextField, StepContent, } from "@mui/material";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Textarea from '@mui/joy/Textarea';
import { AUTHENTICATION, calculateTime, GLOBAL_CONSTANTS, ROUTES, S3DataGetApi, TOASTER_CONFIGS } from "../../constants";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
// import required modules
import { Autoplay, Pagination, Navigation, Keyboard } from 'swiper/modules';
import GoogleMapsComponent from "../../components/GoogleMap";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined';
import { toast } from "react-toastify";
import { FieldArray, Formik } from 'formik';
import * as Yup from 'yup';
import { nullUndefinedEmptyCheck } from "../../utils/helper";
import video from "../../assets/video.png";
import file from "../../assets/files.png";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import { Viewer, Worker } from "@react-pdf-viewer/core";
interface MediaProps {
    loading?: boolean;
}

// Render the  Map view Page size
const containerStyle = {
    width: "100%",
    height: "100%",
};

// Define the style object for the modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const IssuesDetailesView = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const bottomRef = useRef<any>(null);
    const docUploadRef = useRef<any>(null);
    const formikRef = useRef<any>(null);
    const { data: getData } = useIssuesListGetOneQuery(id);
    const [IssueTrackerApi] = useIssuesTrackerMutation();
    const [IssueFeedbackApi] = useIssuesFeedbackMutation();
    const [DetaileList, setDetaileList] = useState<any>('');
    const [open, setOpen] = useState(false);
    const [docOpen, setDocOpen] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [LocationIconView, setLocationIconView] = useState(true);
    const [StepperArray, setStepperArray] = useState<any>([]);
    const [DescriptionText, setDescriptionText] = useState('');
    const [hasProducts, setHasProducts] = useState(true);
    const [attachements, setAttachements] = useState<any>([])

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (getData?.result?.data?.length > 0) {
            setDetaileList(getData?.result?.data[0])
            setDescriptionText(getData?.result?.data[0]?.report_feedback);
            setStepperArray(getData?.result?.data[0]?.report_tracker)
            setAttachements(getData?.result?.data[0]?.report_tracker[2].attachments ?? []);
        }
    }, [id, getData])

    /*Admin or Super-Admin Sidebar Condition*/
    const isSuperAdminToken = sessionStorage.getItem(AUTHENTICATION.SHARED.SUPER_ADMIN);
    const isAdminToken = sessionStorage.getItem(AUTHENTICATION.SHARED.NORMAL_ADMIN);

    const handleRemoveAttachement = (index: any) => {
        if (attachements.indexOf(attachements[index]) > -1) {
            let attachementModified: any = attachements;
            attachementModified.splice(attachements.indexOf(attachements[index]), 1);
            setAttachements(attachementModified);
        }
    }
    const handleFeedback = () => {
        var payload = {
            id: DetaileList?.id,
            report_feedback: DescriptionText
        }
        IssueFeedbackApi(payload)
            .unwrap()
            .then((response) => {
                toast.success(response?.message, TOASTER_CONFIGS);
                navigate(ROUTES.MANAGEISSUE);
            })
            .catch((error) => {
                toast.error(error?.data?.message, TOASTER_CONFIGS);
            })
    }

    const handleTracker = (value: any, trackerStatus: any) => {
        if (trackerStatus) {
            handleNext();
        }
        else {
            let payload: any = {
                id: DetaileList?.report_tracker[activeStep]?.id,
                tracker_status: value?.report_tracker[activeStep]?.tracker_status,
                assigned_name: value?.report_tracker[activeStep]?.assigned_name,
                report_status_feedback: value?.report_tracker[activeStep]?.feedback,
                attachments: ''
            }
            if (activeStep === 1 || activeStep === 2) {
                const selectedAdmin: any = DetaileList?.report_tracker[activeStep]?.department_admin.filter((adminElement: any) => { return adminElement.id === value?.report_tracker[activeStep]?.assigned_name })
                payload['assigned_name'] = value?.report_tracker[activeStep]?.tracker_status === 'Completed' ? selectedAdmin[0].fullname : '';
                payload['assigned_id'] = value?.report_tracker[activeStep]?.tracker_status === 'Completed' ? selectedAdmin[0].id : '';
            }
            if (activeStep === 3) payload['assigned_id'] = sessionStorage.getItem(AUTHENTICATION.SHARED.USER_ID);
            if (activeStep === 2) {
                payload['attachments'] = attachements;
            }
            IssueTrackerApi(payload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    handleNext();
                    setDescriptionText('');
                    if (activeStep === DetaileList?.report_tracker?.length - 1) {
                        // navigate(ROUTES.MANAGEISSUE);
                        setHasProducts(false);
                        bottomRef.current.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        setHasProducts(true);
                    }
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        }
    }

    const validationSchema = Yup.object({
        report_tracker: Yup.array().of(
            Yup.object().shape({
                tracker_status: Yup.string().required('Status is required'),
                assigned_name: Yup.mixed().when('tracker_status', {
                    is: 'Completed',
                    then: (schema: any) => schema.required('Name is required when status is Yes'),
                    otherwise: (schema: any) => schema.notRequired(),
                }),
                feedback: Yup.string().required('Please enter a feedback')
            })
        ),
    });

    const initialValues = () => {
        return {
            report_tracker: StepperArray?.map((tracker: any, index: any) => {
                return ({
                    tracker_status: tracker?.tracker_status ?? '',
                    assigned_name: index === 1 || index === 2 ? tracker?.assigned ? Number(tracker?.assigned) : '' : tracker?.assigned_name ?? '',
                    feedback: tracker?.report_status_feedback ?? ''
                })
            })
        }
    }

    const handleNext = () => {
        if (activeStep === 1) formikRef.current.setFieldValue(`report_tracker[3].assigned_name`, sessionStorage.getItem(AUTHENTICATION.SHARED.NAME))
        if (activeStep < DetaileList.report_tracker.length - 1) {
            setActiveStep((prevStep) => prevStep + 1);
        }
    };

    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep((prevStep) => prevStep - 1);
        }
    };


    /**Handle profile change */
    const handleChange = async (event: any) => {
        // if (event.target.files[0].type.split("/")[0] === "image") {
        try {
            const uploadedImage: any = await S3DataGetApi(event);
            console.log(attachements)
            setAttachements((prevValue: any) => { return [...prevValue, uploadedImage] })
            docUploadRef.current.value = '';
        } catch (error) {
        }
        // } else {
        //     toast.error('Please choose file Image format', TOASTER_CONFIGS);
        // }
    };

    function Media(props: MediaProps) {
        const { loading = false } = props;

        return (
            <Card sx={{ width: '100%', mt: 2 }}>
                <CardHeader
                    avatar={
                        loading ? (
                            <Skeleton animation="wave" variant="circular" width={40} height={40} />
                        ) : (
                            <Avatar
                                alt={DetaileList?.department_name}
                                src={DetaileList?.department_icon}
                            />
                        )
                    }
                    action={
                        loading ? (
                            <Skeleton animation="wave" width="80%" height={10} />
                        ) : (
                            <>
                                <Typography variant="body1">{DetaileList?.Issuer_name}</Typography>
                                <Typography variant="body2" color="text.secondary" component="p">Issue created</Typography>
                            </>
                        )
                    }
                    title={
                        loading ? (
                            <Skeleton
                                animation="wave"
                                height={10}
                                width="80%"
                                style={{ marginBottom: 6 }}
                            />
                        ) : (
                            <>
                                {DetaileList?.department_name}
                            </>
                        )
                    }
                    subheader={
                        loading ? (
                            <Skeleton animation="wave" height={10} width="40%" />
                        ) : (
                            <>
                                {calculateTime(DetaileList?.created_on)}
                            </>
                        )
                    }
                />
                {loading ? (
                    <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
                ) : (
                    <>
                        <Swiper
                            slidesPerView={1}
                            breakpoints={{
                                1080: {
                                    slidesPerView: 1,
                                },
                            }}
                            spaceBetween={17}
                            // navigation={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            keyboard={false}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Keyboard, Navigation, Autoplay]}
                            className={` mySwiper`}
                            style={{ cursor: 'pointer' }}
                        >
                            {DetaileList?.report_image?.length > 0 &&
                                DetaileList?.report_image?.map((item: any, i: any) => {
                                    const isVideo = item?.endsWith('.mp4');
                                    return (
                                        <SwiperSlide key={i}>
                                            <CardMedia
                                                component={isVideo ? 'video' : 'img'}
                                                controls={isVideo ? true : undefined}
                                                height="140"
                                                image={isVideo ? undefined : item}
                                                src={isVideo ? item : undefined}
                                                alt="Media file"
                                                title={isVideo ? 'Sample Video' : 'Sample Image'}
                                                onClick={handleOpen}
                                            />
                                        </SwiperSlide>
                                    )
                                })}
                        </Swiper>
                    </>
                )}
                <CardContent>
                    {loading ? (
                        <>
                            <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                            <Skeleton animation="wave" height={10} width="80%" />
                        </>
                    ) : (
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body2" color="text.secondary" component="p">
                                    {DetaileList?.report_description}
                                </Typography>
                                {DetaileList?.latitude && DetaileList?.longitude && (
                                    <div style={{
                                        cursor: 'pointer', padding: '5px 7px',
                                        fontSize: 18,
                                        border: `3px solid ${LocationIconView ? GLOBAL_CONSTANTS.COLOR_CODE.PRIMARY : ''}`,
                                        color: `${LocationIconView ? GLOBAL_CONSTANTS.COLOR_CODE.PRIMARY : ''}`
                                    }} title="Map View"
                                        onClick={() => setLocationIconView(!LocationIconView)}>
                                        {LocationIconView ? (
                                            <LocationOnOutlinedIcon />
                                        ) : (
                                            <LocationOffOutlinedIcon />
                                        )}
                                    </div>
                                )}
                            </Box>
                        </>
                    )}
                </CardContent>
            </Card>
        );
    }

    return (
        <>
            <Grid container spacing={2} marginTop={1} marginBottom={2}>
                <Grid item xs={12} sm={2}>
                    <Box
                        sx={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}
                        onClick={() => navigate(-1)}>
                        <KeyboardArrowLeftIcon />
                        <Typography>
                            Detail View
                        </Typography>
                    </Box>

                </Grid>
                <Grid item xs={12} sm={4}>
                    {DetaileList?.risk_evaluation && (
                        <Box
                            sx={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', textTransform: 'capitalize' }}
                            onClick={() => navigate(-1)}>
                            <Typography>Priority level :</Typography>
                            <Typography variant="body2" color="text.secondary" component="p">
                                {DetaileList?.risk_evaluation}</Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>

            <Grid container spacing={2} ref={bottomRef}>
                <Grid item xs={12} sm={6}>
                    {DetaileList ? (
                        <Media />
                    ) : (
                        <Media loading />
                    )}
                    <Box sx={{
                        backgroundColor: '#e7eaed',
                        padding: '10px',
                        margin: '15px 0',
                        borderRadius: '5px'
                    }}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <Typography variant="body1" sx={{ textWrap: 'nowrap' }}>Reported Location : </Typography>
                            <Typography variant="body2" color="text.secondary" component="p">{DetaileList?.report_location}</Typography>
                        </div>
                        <div style={{ display: 'flex', gap: '7px' }}>
                            <Typography variant="body1" sx={{ textWrap: 'nowrap' }} >Reported Address  : </Typography>
                            <Typography variant="body2" color="text.secondary" component="p">{DetaileList?.report_map_address}</Typography>
                        </div>
                    </Box>
                    {DetaileList?.latitude && DetaileList?.longitude && LocationIconView && (
                        <Box sx={{ widows: 300, height: 230 }}>
                            <GoogleMapsComponent
                                zoom={12}
                                lat={DetaileList?.latitude}
                                lang={DetaileList?.longitude}
                                containerStyle={containerStyle}
                                disable={false}
                                zoomControl={true}
                                clickableIcons={true}
                                draggable={true} />
                        </Box>
                    )}
                </Grid>
                {DetaileList?.is_all_completed ? (
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ maxWidth: '100%', mb: 3, display: 'flex', }}>
                            <Stepper activeStep={activeStep} orientation="vertical">
                                {DetaileList?.report_tracker?.map((step: any, index: any) => (
                                    <Step key={index} sx={{ width: '100%', }}>
                                        <StepLabel>{step?.status_name}</StepLabel>
                                        <StepContent sx={{ width: '100%' }}>
                                            <Grid container spacing={2} sx={{ mt: 1, }}>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography variant="body2" color="text.secondary">{step?.description_question}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography>{step?.tracker_status === 'Completed' ? 'Yes' : 'No'}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography variant="body2" color="text.secondary">{step?.description_name}</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography>{step?.assigned_name}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Box sx={{ mt: 1 }}>
                                                <div>
                                                    {activeStep !== 3 &&
                                                        <Button
                                                            variant="contained"
                                                            disabled={index === DetaileList?.report_tracker?.length - 1}
                                                            onClick={() =>
                                                                setActiveStep((prevActiveStep) => prevActiveStep + 1)
                                                            }
                                                            sx={{ mt: 1, mr: 1 }}
                                                        >
                                                            Continue
                                                        </Button>
                                                    }
                                                    <Button
                                                        disabled={index === 0}
                                                        onClick={() =>
                                                            setActiveStep((prevActiveStep) => prevActiveStep - 1)
                                                        }
                                                        sx={{ mt: 1, mr: 1 }}
                                                    >
                                                        Back
                                                    </Button>
                                                </div>
                                            </Box>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                        {/* <Typography sx={{ m: 2 }}>Type Here Feedback/Comments</Typography>
                        <Box sx={{ maxWidth: '100%', m: 2 }}>
                            <Textarea minRows={5} maxRows={8} variant="soft"
                                placeholder="Type in here…" value={DescriptionText}
                                onChange={(e) => setDescriptionText(e.target.value)}
                            />
                            {DescriptionText && (
                                <Button variant="contained" sx={{ mt: 1, mr: 1, float: 'right' }}
                                    onClick={handleFeedback}>
                                    Submit
                                </Button>
                            )}
                        </Box> */}
                    </Grid>
                ) : (
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ maxWidth: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {DetaileList?.report_tracker?.map((step: any, index: any) => (
                                    <Step key={index}>
                                        <StepLabel>{step?.status_name}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            {DetaileList?.report_tracker?.length > 0 && (
                                <>
                                    <Formik
                                        initialValues={initialValues()}
                                        validationSchema={validationSchema}
                                        onSubmit={(values, actions) => { }}
                                        enableReinitialize={true}
                                        innerRef={formikRef}
                                        validateOnChange={false}
                                        validateOnBlur={true}
                                    >
                                        {(formik: any) => (
                                            <>
                                                <FieldArray
                                                    name="report_tracker"
                                                    render={() => (
                                                        <>
                                                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography sx={{ m: 2 }}>{DetaileList?.report_tracker[activeStep]?.description_question}</Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            formik?.touched.report_tracker?.[activeStep]?.tracker_status &&
                                                                            Boolean(formik.errors.report_tracker?.[activeStep]?.tracker_status)
                                                                        }
                                                                    >
                                                                        <Select
                                                                            labelId={`status-label-${activeStep}`}
                                                                            id={`status-${activeStep}`}
                                                                            name={`report_tracker.${activeStep}.tracker_status`}
                                                                            value={formik?.values?.report_tracker[activeStep]?.tracker_status ?? ''}
                                                                            onChange={(event) => {
                                                                                formik.setFieldValue(`report_tracker.${activeStep}.tracker_status`, event.target.value);
                                                                            }}
                                                                            onBlur={formik?.handleBlur}
                                                                        >
                                                                            <MenuItem value="Pending">No</MenuItem>
                                                                            <MenuItem value="Completed">Yes</MenuItem>
                                                                        </Select>
                                                                        {formik?.touched.report_tracker?.[activeStep]?.tracker_status &&
                                                                            formik.errors.report_tracker?.[activeStep]?.tracker_status && (
                                                                                <Typography color="error">{formik.errors.report_tracker[activeStep].tracker_status}</Typography>
                                                                            )}
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography sx={{ m: 2 }}>{DetaileList?.report_tracker[activeStep]?.description_name}</Typography>
                                                                </Grid>
                                                                {formik.values.report_tracker[activeStep].tracker_status === 'Completed' && (
                                                                    <Grid item xs={12} sm={6}>
                                                                        {activeStep === 1 || activeStep === 2 ?

                                                                            <FormControl
                                                                                fullWidth
                                                                                error={
                                                                                    formik?.touched.report_tracker?.[activeStep]?.assigned_name &&
                                                                                    Boolean(formik.errors.report_tracker?.[activeStep]?.assigned_name)
                                                                                }
                                                                            >
                                                                                <Select
                                                                                    labelId={`assigned-label-${activeStep}`}
                                                                                    id={`assigned-${activeStep}`}
                                                                                    name={`report_tracker.${activeStep}.assigned_name`}
                                                                                    value={formik?.values?.report_tracker[activeStep]?.assigned_name ?? ''}
                                                                                    onChange={(event) => {
                                                                                        formik.setFieldValue(`report_tracker.${activeStep}.assigned_name`, event.target.value);
                                                                                    }}
                                                                                    onBlur={formik?.handleBlur}
                                                                                >
                                                                                    {DetaileList?.report_tracker[activeStep]?.department_admin.map((departmentAdminElement: any) => (
                                                                                        <MenuItem value={departmentAdminElement.id}>{departmentAdminElement.fullname}</MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                                {formik?.touched.report_tracker?.[activeStep]?.assigned_name && formik.errors.report_tracker?.[activeStep]?.assigned_name && (
                                                                                    <Typography color="error">{formik.errors.report_tracker[activeStep].assigned_name}</Typography>
                                                                                )}
                                                                            </FormControl> :
                                                                            <TextField
                                                                                fullWidth
                                                                                id={`name-${activeStep}`}
                                                                                label="Name"
                                                                                name={`report_tracker.${activeStep}.assigned_name`}
                                                                                value={formik.values.report_tracker[activeStep].assigned_name ?? ''}
                                                                                onChange={(event) => {
                                                                                    formik.setFieldValue(`report_tracker.${activeStep}.assigned_name`, event.target.value);
                                                                                }}
                                                                                onBlur={formik.handleBlur}
                                                                                error={
                                                                                    formik?.touched.report_tracker?.[activeStep]?.assigned_name &&
                                                                                    Boolean(formik.errors.report_tracker?.[activeStep]?.assigned_name)
                                                                                }
                                                                                helperText={
                                                                                    formik?.touched.report_tracker?.[activeStep]?.assigned_name &&
                                                                                    formik.errors.report_tracker?.[activeStep]?.assigned_name
                                                                                }
                                                                            />
                                                                        }
                                                                    </Grid>
                                                                )}
                                                                {activeStep === 2 &&
                                                                    <Grid container spacing={2} sx={{ m: 2 }}>
                                                                        {attachements?.map((files: any, index: any) => (
                                                                            <Grid item xs={4} md={3}>
                                                                                <Box sx={[{ position: 'relative' }]}>
                                                                                    <IconButton
                                                                                        aria-label="close"
                                                                                        onClick={() => handleRemoveAttachement(index)}
                                                                                        sx={{
                                                                                            position: 'absolute',
                                                                                            zIndex: 1,
                                                                                            backgroundColor: '#fff',
                                                                                            top: '-10px',
                                                                                            right: '-10px',
                                                                                            p: 0,
                                                                                            color: (theme) => theme.palette.grey[500],
                                                                                            '&:hover': {
                                                                                                color: 'white',
                                                                                            },
                                                                                        }}
                                                                                    >
                                                                                        <CloseIcon />
                                                                                    </IconButton>
                                                                                    {['png', 'jpg', 'jpeg', 'svg'].filter((elements) => { return files.split('.')[files.split('.').length - 1].includes(elements) }).length > 0 &&
                                                                                        <Box component='img' src={files} sx={[{ border: '1px solid #00000061', width: '100%', height: "72px", objectFit: 'cover' }]} onClick={() => setDocOpen(true)} />
                                                                                    }
                                                                                    {['mov', 'mp4', 'mkv'].filter((elements) => { return files.split('.')[files.split('.').length - 1].includes(elements) }).length > 0 &&
                                                                                        <Box component='img' src={video} sx={[{ border: '1px solid #00000061', width: '100%', height: "72px", objectFit: 'contain', p: 2, boxSizing: 'border-box' }]} onClick={() => setDocOpen(true)} />
                                                                                    }
                                                                                    {/* {['pdf'].filter((elements) => { return files.split('.')[files.split('.').length - 1].includes(elements) }).length > 0 &&
                                                                                <Box component='img' src={file} sx={[{ border: '1px solid #00000061', width: '100%', height: "72px", objectFit: 'contain', p: 2, boxSizing: 'border-box' }]} onClick={() => setDocOpen(true)} />
                                                                            } */}
                                                                                </Box>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                }
                                                                {activeStep === 2 && isSuperAdminToken !== 'true' && isAdminToken === 'true' &&
                                                                    <Grid item xs={12}>
                                                                        <Typography sx={{ m: 2 }}>Issue fixed attachment</Typography>
                                                                        <TextField
                                                                            type='file'
                                                                            id="docUploadControlled"
                                                                            name="category_icon"
                                                                            placeholder='choose '
                                                                            onChange={(e) => {
                                                                                formik.handleChange(e);
                                                                                handleChange(e);
                                                                            }}
                                                                            inputRef={docUploadRef}
                                                                            inputProps={{ accept: "image/png,image/jpg,image/jpeg,image/svg,.mov,.mp4,.mkv" }}
                                                                            sx={[{ m: 2 }]}
                                                                            onBlur={formik.handleBlur}
                                                                        // error={formik.touched.category_icon && Boolean(formik.errors.category_icon)}
                                                                        // helperText={formik.touched.category_icon && formik.errors.category_icon}
                                                                        />
                                                                    </Grid>
                                                                }
                                                                <Grid item xs={12}>
                                                                    <Box sx={{ maxWidth: '100%', m: 2 }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            multiline
                                                                            rows={4}
                                                                            id={`name-${activeStep}-feedback`}
                                                                            label="Type Here Feedback/Comments"
                                                                            placeholder="Type in here…"
                                                                            name='feedback'
                                                                            value={formik.values.report_tracker[activeStep].feedback ?? ''}
                                                                            onChange={(event) => {
                                                                                const value = event.target.value;
                                                                                formik.setFieldValue(`report_tracker.${activeStep}.feedback`, value);

                                                                                // Trigger validation manually on change
                                                                                if (formik.touched.report_tracker?.[activeStep]?.feedback) {
                                                                                    formik.validateField(`report_tracker.${activeStep}.feedback`);
                                                                                }
                                                                            }}
                                                                            onFocus={() => {
                                                                                formik.setFieldTouched(`report_tracker.${activeStep}.feedback`, true);
                                                                            }}
                                                                            onBlur={(event) => {
                                                                                formik.handleBlur(event);

                                                                                // Ensure validation runs on blur
                                                                                formik.validateField(`report_tracker.${activeStep}.feedback`);
                                                                            }}
                                                                            error={
                                                                                formik?.touched.report_tracker?.[activeStep]?.feedback &&
                                                                                Boolean(formik.errors.report_tracker?.[activeStep]?.feedback)
                                                                            }
                                                                            helperText={
                                                                                formik?.touched.report_tracker?.[activeStep]?.feedback &&
                                                                                formik.errors.report_tracker?.[activeStep]?.feedback
                                                                            }
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )}
                                                />
                                                {activeStep === 2 && !DetaileList?.report_tracker[2]?.is_status && isSuperAdminToken === 'true' &&
                                                    <Typography component='caption' sx={[{ color: '#d32f2f' }]} align='center'>Note: Issue is not updated by the Admin</Typography>
                                                }
                                                {activeStep === 3 && isAdminToken === 'true' &&
                                                    <Typography component='caption' sx={[{ color: '#d32f2f' }]} align='center'>Note: Please wait for super admin to verify and close the issue</Typography>
                                                }
                                                <Box sx={{ m: 2 }}>
                                                    <div>
                                                        <Button variant="contained" type="submit"
                                                            disabled={(formik.values?.report_tracker[activeStep]?.tracker_status !== 'Completed' || Boolean(formik.errors.report_tracker?.[activeStep]?.feedback) || (isSuperAdminToken === 'true' && activeStep === 2 && !DetaileList?.report_tracker[2]?.is_status) || (isAdminToken === 'true' && !nullUndefinedEmptyCheck(formik.values?.report_tracker[activeStep]?.assigned_name)) || (isAdminToken === 'true' && activeStep === 2 && attachements?.length === 0))}
                                                            onClick={() => {
                                                                handleTracker(formik.values, DetaileList?.report_tracker[activeStep]?.is_status)
                                                            }} sx={{ mt: 1, mr: 1 }}>
                                                            {activeStep === DetaileList?.report_tracker?.length - 1 ? 'Finish' : 'Next'}
                                                        </Button>
                                                        <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                                                            Back
                                                        </Button>
                                                    </div>
                                                </Box>

                                            </>
                                        )}
                                    </Formik>
                                </>
                            )}
                        </Box>

                    </Grid>
                )}
            </Grid >

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
            >
                <Box sx={{ ...style, width: '60%' }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            zIndex: 10000,
                            top: 8,
                            right: 8,
                            color: (theme) => theme.palette.grey[500],
                            '&:hover': {
                                color: 'white',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Swiper
                        slidesPerView={1}
                        breakpoints={{
                            1080: {
                                slidesPerView: 1,
                            },
                        }}
                        spaceBetween={17}
                        navigation={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        keyboard={true}
                        modules={[Pagination, Keyboard, Navigation]}
                        className="mySwiper"
                    >
                        {DetaileList?.report_image?.length > 0 &&
                            DetaileList?.report_image?.map((item: any, i: any) => {
                                const isVideo = item.endsWith('.mp4');
                                return (
                                    <SwiperSlide key={i}>
                                        {isVideo ? (
                                            <CardMedia
                                                component="video"
                                                controls
                                                height="400"
                                                src={item}
                                                title="Sample Video"
                                            />
                                        ) : (
                                            <CardMedia
                                                component="img"
                                                height="400"
                                                image={item}
                                                alt="report img"
                                            />
                                        )}
                                    </SwiperSlide>
                                )
                            })}
                    </Swiper>
                </Box>
            </Modal>

            <Modal
                open={docOpen}
                onClose={() => setDocOpen(false)}
                aria-labelledby="child-modal-title"
            >
                <Box sx={{ ...style, width: '60%' }}>
                    <IconButton
                        aria-label="close"
                        onClick={() => setDocOpen(false)}
                        sx={{
                            position: 'absolute',
                            zIndex: 10000,
                            top: 8,
                            right: 8,
                            color: (theme) => theme.palette.grey[500],
                            '&:hover': {
                                color: 'white',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Swiper
                        slidesPerView={1}
                        breakpoints={{
                            1080: {
                                slidesPerView: 1,
                            },
                        }}
                        spaceBetween={17}
                        navigation={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        modules={[Navigation]}
                        className="mySwiper"
                    >
                        {attachements?.length > 0 &&
                            attachements?.map((item: any, i: any) => {
                                const isVideo = item.endsWith('.mp4') || item.endsWith('.mov') || item.endsWith('.mkv');
                                const isPdf = item.endsWith('.pdf')
                                const isImg = item.endsWith('.png') || item.endsWith('.jpg') || item.endsWith('.jpeg') || item.endsWith('.svg')
                                return (
                                    <SwiperSlide key={i}>
                                        {isVideo && (
                                            <CardMedia
                                                component="video"
                                                controls
                                                height="400"
                                                src={item}
                                                title="Sample Video"
                                                sx={[{ objectFit: 'contain' }]}
                                            />
                                        )}
                                        {isImg && (
                                            <CardMedia
                                                component="img"
                                                height="400"
                                                image={item}
                                                alt="report img"
                                                sx={[{ objectFit: 'contain' }]}
                                            />
                                        )}
                                        {/* {isPdf &&
                                            <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js'>
                                                <Viewer fileUrl={item} />
                                            </Worker>} */}
                                    </SwiperSlide>
                                )
                            })}
                    </Swiper>
                </Box>
            </Modal>
        </>
    )
}

export default IssuesDetailesView;